// Helper function to determine if the current environment is production
const isProduction = () => {
    const domain = window.location.hostname;
    return ['app.theyellowapp.com', 'www.theyellowapp.com', 'theyellowapp.com'].includes(domain);
};

// Utility function to get the API URL
export const getApiUrl = () => {
    return isProduction() ? 'https://api.theyellowapp.com' : 'https://api-dev.theyellowapp.com';
};

// Utility function to get the Web App URL
export const getWebAppUrl = () => {
    return isProduction() ? 'https://app.theyellowapp.com' : 'https://app-dev.theyellowapp.com';
};
